// import React, { useState } from 'react';
// import Orders from './Orders';
// import AssignedOrdersTable from './AssignedOrdersTable';
// import Orders1 from './Orders1';
// import Headerpage from '../Headerpage';
// import './OrdersPage.css';

// function OrdersPage() {
//   const [activePage, setActivePage] = useState('orders'); // default view

//   const renderContent = () => {
//     switch (activePage) {
//       case 'orders':
//         return <Orders />;
//       case 'ordersMenu':
//         return <Orders1 />;
//       case 'assigned':
//         return <AssignedOrdersTable />;
//       default:
//         return <Orders />;
//     }
//   };

//   return (
//     <div className="orders-dashboard">
//       <Headerpage />
//       <div className="orders-layout">
//         {/* Sidebar */}
//         <nav className="orders-sidebar" aria-label="Orders Navigation">
//           <button
//             className={activePage === 'orders' ? 'active' : ''}
//             onClick={() => setActivePage('orders')}
//             aria-current={activePage === 'orders' ? 'page' : undefined}
//           >
//             Orders
//           </button>

//           <button
//             className={activePage === 'ordersMenu' ? 'active' : ''}
//             onClick={() => setActivePage('ordersMenu')}
//             aria-current={activePage === 'ordersMenu' ? 'page' : undefined}
//           >
//             Orders Status Flow
//           </button>

//           <button
//             className={activePage === 'assigned' ? 'active' : ''}
//             onClick={() => setActivePage('assigned')}
//             aria-current={activePage === 'assigned' ? 'page' : undefined}
//           >
//             Assigned Orders
//           </button>
//         </nav>

//         {/* Main Content */}
//         <main className="orders-content">
//           {renderContent()}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default OrdersPage;












import React, { useState } from 'react';
import Orders from './Orders';
import AssignedOrdersTable from './AssignedOrdersTable';
import Orders1 from './Orders1';
import Headerpage from '../Headerpage';
import './OrdersPage.css';

function OrdersPage() {
  const [activePage, setActivePage] = useState('orders'); // default view

  const renderContent = () => {
    switch (activePage) {
      case 'orders':
        return <Orders />;
      case 'ordersMenu':
        return <Orders1 />;
      case 'assigned':
        return <AssignedOrdersTable />;
      default:
        return <Orders />;
    }
  };

  return (
    <div className="orders-dashboard">
      <Headerpage />
      <div className="orders-layout">
        {/* Sidebar */}
        <nav className="orders-sidebar" aria-label="Orders Navigation">
          <button
            className={activePage === 'orders' ? 'active' : ''}
            onClick={() => setActivePage('orders')}
            aria-current={activePage === 'orders' ? 'page' : undefined}
          >
            Orders
          </button>

          <button
            className={activePage === 'ordersMenu' ? 'active' : ''}
            onClick={() => setActivePage('ordersMenu')}
            aria-current={activePage === 'ordersMenu' ? 'page' : undefined}
          >
            Orders Status Flow
          </button>

          <button
            className={activePage === 'assigned' ? 'active' : ''}
            onClick={() => setActivePage('assigned')}
            aria-current={activePage === 'assigned' ? 'page' : undefined}
          >
            Assigned Orders
          </button>
        </nav>

        {/* Main Content */}
        <main className="orders-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}

export default OrdersPage;
